module.exports = __webpack_public_path__ + "static/media/youtube-shorts.7c06bcd9.png";